<template>
  <div class="login-header-page">
    <div class="login-header-content">
      <div class="login-header-left">
        <img class="login-header-logo" style="" src="../../../public/static/index-logo.png"/>
        <a-divider class="login-header_left-divider" type="vertical"/>
        <div class="login-header_left-title">{{ loginTitle }}</div>
      </div>
      <div class="login-header-right">
        <div class="top-content-help-center" @click="gotoHelp">
          <dol-icon class="top-content-right-icon" type="question" />
          <span class="top-content-help-center-text" >{{ $t('helpCenter') }}</span>
        </div>

        <a-icon :style="{ color: '#000',fontSize: '14px',marginRight: '8px' }" type="global"/>
        <a-dropdown>
          <span style="color: #333333;font-size: 14px">
            {{ langText }}
            <a-icon type="down"/>
          </span>
          <a-menu slot="overlay">
            <a-menu-item>
              <span :class="{active: $i18n.locale === 'zh'}" @click="changeLang('zh')">{{$t('langCh')}}</span>
            </a-menu-item>
            <a-menu-item>
              <span :class="{active: $i18n.locale === 'en'}" @click="changeLang('en')">{{$t('langEng')}}</span>
            </a-menu-item>
            <a-menu-item>
              <span :class="{active: $i18n.locale === 'ru'}" @click="changeLang('ru')">{{$t('langRus')}}</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-divider class="login-header_right-divider" type="vertical"/>
        <div style="color: #333333" v-if="$route.path === '/register'">
          {{ $t('haveANetcomAccount') }}？<a @click="$router.push('login')">{{ $t('pleaseLogin') }}</a>
        </div>
        <a v-else @click="$router.push('index')">{{ $t('index') }}</a>
      </div>
      <div v-if="$route.path === '/register'" class="top-content-role">
        {{ $t('cargoRole') }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "loginHeader",
  data() {
    return {
      langText: this.$t('langCh'),
      langObj:{
        zh: this.$t('langCh'),
        en: this.$t('langEng'),
        ru: this.$t('langRus')
      }
    }
  },
  watch:{
    '$i18n.locale'(){
      this.menuList={
        companyRegister:this.$t('enterpriseCertification'),
        register:this.$t('IndividualRegistration'),
        login:this.$t('welcomeToUse'),
        registerSucceed:this.$t('welcomeToUse'),
      }
    }
  },
  computed: {
    loginTitle() {
      if (this.$route.name === 'register') {
        return this.$t('IndividualRegistration')
      } else if (this.$route.name === 'companyRegister') {
        return this.$t('businessRegistration')
      } else {
        return this.$t('welcomeToUse')
      }
    }
  },
  methods:{
    gotoHelp() {
      this.$router.push('/help/helpCenter')
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      this.langText = this.langObj[lang];
      localStorage.setItem('lang', lang)
      moment.locale(lang === 'zh' ? 'zh-cn' : lang);
      this.$moment.locale(lang === 'zh' ? 'zh-cn' : lang);
    },
  },
  created() {
    this.changeLang(this.$i18n.locale)
  }
}
</script>

<style lang="scss" scoped>
.login-header-page {
  background-color: #FFFFFF;

  .login-header-content {
    width: 990px;
    height: 80px;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .login-header-left {
      display: flex;
      align-items: center;

      .login-header-logo {
        padding-bottom: 10px;
        color: #1F6CBA;
        width: 160px;
        height: 40px;
      }

      .login-header_left-divider {
        height: 30px;
        background-color: #DDDDDD;
        margin: 0 24px;
      }

      .login-header_left-title {
        font-size: 24px;
        font-weight: 700;
      }
    }

    .login-header-right {
      display: flex;
      align-items: center;
      color: rgba(206, 198, 198, 0.5);
      .top-content-help-center{
        display: flex;
        align-items: center;
        cursor: pointer;
        .top-content-right-icon{
          font-size: 14px;
          color: #333333;
          margin-right: 6px;
        }
        .top-content-help-center-text{
          color: #333333;
          font-size: 14px;
          padding-right: 12px;
        }
      }
      .login-header_right-divider {
        height: 13px;
        margin: 0 15px;
      }

      span {
        font-size: 16px;
        cursor: pointer;
        line-height: 1;
        font-weight: 700;

        &.active {
          color: #333333;
        }
      }
    }

    .top-content-role {
      position: absolute;
      bottom: 5px;
      left: 50%;
      font-weight: 700;
    }
  }
}
</style>